import { useMutation } from "@tanstack/react-query";

import { postNok } from "../api/nok";

const usePostNok = () => {
  const mutation = useMutation({
    mutationFn: postNok,
  });
  return mutation;
};

export default usePostNok;
